import React, { Component } from 'react'
import logo from './logo.svg'
import './App.css'

import Home from './pages/Home'
import Result from './pages/Result'

class App extends Component {
  state = {
    images: [],
  }

  render() {
    const { images } = this.state
    return (
      <div className="App">
        {images.length ? (
          <Result images={images} />
        ) : (
          <Home onUpload={images => this.setState({ images })} />
        )}
      </div>
    )
  }
}

export default App
